import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  backdrop: {
    color: theme.colors.light.freshPowder,
    zIndex: theme.zIndex.drawer + 2000,
  },
  header: {
    width: '100%',
    height: '60px',
    fontWeight: 700,
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.dark.darkNavy,
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 200,
  },
  headerInner: {
    display: 'flex',
    alignItems: 'center',
    padding: '18px 24px',
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  flexEnd: {
    justifyContent: 'flex-end',
  },
  backButton: {
    padding: 0,
    border: 0,
    background: 'none',
  },
  hidden: {
    display: 'none',
  },
  headerLogo: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  headerLogoCentered: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
  },
  headerLogoImg: {
    filter: `drop-shadow(0px 0px 4px ${theme.colors.light.freshPowder})`,
  },
  headerImg: {
    display: 'block',
    width: 20,
    height: 21,
  },
  headerLettering: {
    margin: '0 6px',
    fontFamily: theme.fonts.family.secondary,
  },
  headerBar: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    overflow: 'hidden',
    transition: 'all .2s ease-in-out',
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.orange.orange,
    height: 35,
    width: 40,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.colors.orange.darkOrange,
    },
  },
}));
